import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef, createContext, useContext } from 'react';
import { Flex } from '../Flex/index.js';

const statuses = {
  error: {
    icon: 'ErrorCircle',
    color: 'watermelon'
  },
  warning: {
    icon: 'NotOnboarded',
    color: 'marigold'
  },
  info: {
    icon: 'Information',
    color: 'turquoise'
  },
  success: {
    icon: 'CheckCircle',
    color: 'aloe'
  }
};
/* ======================================= */
const AlertContext = /*#__PURE__*/createContext({});
const useAlertContext = () => useContext(AlertContext);
/* ======================================= */
/**
 * Alerts are used to communicate a state that affects a system, feature or page.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/alert#usage)
 * - [Props](https://blockparty.endpoint.com/components/alert#props)
 * <br />
 *
 */
const Alert = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    status = 'info',
    ...props
  } = _ref;
  const values = {
    status
  };
  const bgColor = statuses[status] && `${statuses[status].color}0`;
  return /*#__PURE__*/React__default.createElement(AlertContext.Provider, {
    value: values
  }, /*#__PURE__*/React__default.createElement(Flex, _extends({
    ref: forwardedRef,
    backgroundColor: bgColor,
    borderRadius: "radiusDefault",
    p: "space50",
    role: "status"
  }, props), children));
});

export { Alert, AlertContext, statuses, useAlertContext };
